import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getErrorMessage } from 'Core/helpers';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly notificationService: NzNotificationService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || request.url.includes('/auth/login')) {
          return throwError(() => error);
        }

        this.notificationService.error('', getErrorMessage(error));
        return throwError(() => error);
      })
    );
  }
}
